// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sp-1";
export var stateContainer = "_sp-0";